import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export type ContactsLastImportId = number

export enum ContactsImportStatus {
  approved = 'approved',
  failed = 'failed',
  suspended = 'suspended',
}

export interface ContactsLastImportsInterface {
  id: ContactsLastImportId
  contactsCount: number
  processedContactsCount: number
  invalidContactsCount: number
  date: string
  status: ContactsImportStatus
}

export type ContactsLastImportsApiInterface =
  DataWithPaginationInterface<ContactsLastImportsInterface>

export interface ContactsImportFilterInterface {
  date: [dateSince: string | null, dateTill: string | null]
}
